import { inject, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
    name: "trustedHtml"
})
export class TrustedHtmlPipe implements PipeTransform {
    private sanitizer = inject(DomSanitizer);

    public transform(html: string) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
